<template>
  <v-container>
    <v-row>
      <v-col cols="4">
        <v-card class="ui-module-card ui-module-fade-in-up pa-2" color="primary" dense height="64">
          <v-container>
            <v-row align="center">
              <v-col cols="6">
                <div class="text-subtitle-2 font-weight-bold">Asistieron</div>
              </v-col>
              <v-col cols="6" align="right">
                <div class="d-inline text-subtitle-1 font-weight-black">{{ totalAsistidos }}</div>
                <div class="d-inline text-subtitle-1 mx-2">de</div>
                <div class="d-inline text-subtitle-1 font-weight-black">{{ personal.length }}</div>
              </v-col>
            </v-row>
          </v-container>
        </v-card>
      </v-col>
      <v-col cols="4">
        <v-card class="ui-module-card ui-module-fade-in-up pa-2" color="primary" dense height="64">
          <v-container>
            <v-row align="center">
              <v-col cols="8">
                <div class="text-subtitle-2 font-weight-bold">Promedio general</div>
              </v-col>
              <v-col cols="4" align="right">
                <div class="text-subtitle-1 font-weight-black">{{ promedioGeneral }}</div>
              </v-col>
            </v-row>
          </v-container>
        </v-card>
      </v-col>
      <v-col cols="12" lg="4">
        <v-text-field
          v-model="buscaPersonal"
          color="secondary"
          background-color="primary"
          rounded
          filled
          placeholder="Buscar personal por nombre, edad, municipio o estado..."
          append-icon="mdi-magnify"
        ></v-text-field>
      </v-col>
      <v-col cols="12 mb-3" align="right">
        <TextButton
          class="secondary ui-module-btn-solid ui-module-fade-in-up mt-2 px-8"
          rounded
          elevation="8"
          v-on:click="save()"
          :disabled="loading"
          :loading="loading"
        >
          Guardar evaluación <v-icon small class="ml-2">mdi-plus</v-icon>
        </TextButton>
      </v-col>
    </v-row>
    <v-row>
      <v-col cols="12" v-if="buscaPersonal.length > 0">
        <div class="text-h6 font-weight-bold">
          {{ filteredPersonal.length }} resultados encontrados con la búsqueda "{{ buscaPersonal }}"
        </div>
      </v-col>
      <v-col cols="12">
        <v-data-table
          :headers="headers"
          :items="itemsCurso"
          class="transparent ui-module-table"
          hide-default-footer
          disable-pagination
          dense
        >
          <template v-slot:[`item.CUIP`]="{ item }">
            <div>{{ item.CUIP }}</div>
          </template>
          <template v-slot:[`item.nombre`]="{ item }">
            <div>{{ item.nombre }}</div>
          </template>
          <template v-slot:[`item.segundoNombre`]="{ item }">
            <div>{{ item.segundoNombre }}</div>
          </template>
          <template v-slot:[`item.apaterno`]="{ item }">
            <div>{{ item.apaterno }}</div>
          </template>
          <template v-slot:[`item.amaterno`]="{ item }">
            <div>{{ item.amaterno }}</div>
          </template>
          <template v-slot:[`item.asistencia`]="{ item }">
            <v-icon :color="item.asistencia ? 'success' : 'error'">
              {{ item.asistencia ? 'mdi-check-circle' : 'mdi-close-circle' }}
            </v-icon>
          </template>
          <template v-slot:[`item.calificacion`]="{ item }">
            <div>{{ item.calificacion }}</div>
          </template>
          <template v-slot:[`item.calificacionEvaluacion`]="{ item }">
            <div>{{ item.calificacionEvaluacion }}</div>
          </template>
          <template v-slot:[`item.comentario`]="{ item }">
            <div style="white-space: pre-line">{{ item.comentario }}</div>
          </template>
          <template v-slot:[`item.acciones`]="{ item }">
            <span class="d-inline-flex">
              <v-btn icon color="secondary" class="ui-module-icon-action" small @click="openEditModalCalificar(item)">
                <v-icon>mdi-message-draw</v-icon>
              </v-btn>
              <v-btn icon color="secondary" class="ui-module-icon-action" small @click="openEditModalDelete(item)">
                <v-icon>mdi-delete-outline</v-icon>
              </v-btn>
            </span>
          </template>
        </v-data-table>
      </v-col>
    </v-row>
  </v-container>
</template>
<script>
import { mapGetters, mapActions, mapMutations } from 'vuex'
import { textInputProps } from '../../components/props/props'
import { DIALOG_TYPES } from '../../plugins/dialog-types'
import TextButton from '@/components/base/TextButton.vue'

export default {
  components: {
    TextButton,
  },
  props: {
    id: {
      type: Number,
    },
  },

  data() {
    return {
      textInputProps,
      buscaPersonal: '',
      ordenAlfabetico: 0,
      loading: false,
      headers: [
        { text: 'CUIP', value: 'cuip', align: 'center' },
        { text: 'Nombre', value: 'nombre', align: 'center' },
        { text: '2° Nombre', value: 'segundoNombre', align: 'center' },
        { text: 'A. Paterno', value: 'apaterno', align: 'center' },
        { text: 'A. Materno', value: 'amaterno', align: 'center' },
        { text: 'Asist.', value: 'asistencia', sortable: false, align: 'center' },
        { text: 'Calif.', value: 'calificacion', align: 'center' },
        { text: 'Calif. Eval.', value: 'calificacionEvaluacion', align: 'center' },
        { text: 'Comentario', value: 'comentario', align: 'center' },
        { text: 'Opciones', value: 'acciones', sortable: false, align: 'center' },
      ],
      DIALOG_TYPES,
    }
  },

  computed: {
    ...mapGetters('cursoAsignado', {
      personalCurso: 'getCursosAsignados',
    }),
    ...mapGetters('cursoProgramado', { cursosProgramados: 'getCursosProgramados' }),

    personal: function () {
      return this.personalCurso.filter((cursoPersonal) => {
        return cursoPersonal.fk_idProgramacionCurso == this.id
      })
    },

    filteredPersonal: function () {
      return this.personal.filter((cursoPersonal) => {
        return cursoPersonal
      })
    },

    totalAsistidos: function () {
      var total = 0
      this.personal.forEach((cursoPersonal) => {
        if (cursoPersonal.asistencia == true) {
          total++
        }
      })
      return total
    },

    promedioGeneral: function () {
      let suma = 0
      let total = 0

      this.personal.forEach((cursoPersonal) => {
        if (
          cursoPersonal.asistencia === true &&
          cursoPersonal.calificacion &&
          !isNaN(parseFloat(cursoPersonal.calificacion))
        ) {
          suma += parseFloat(cursoPersonal.calificacion)
          total++
        }
      })

      if (total === 0) return 0
      return (suma / total).toFixed(1)
    },

    groupedPersonal: function () {
      var result = _(this.filteredPersonal)
        .groupBy((cursoPersonal) => cursoPersonal.Personal.apaterno[0].toUpperCase())
        .map((cursoPersonal, inicial) => ({ inicial, cursoPersonal }))
        .value()

      if (this.ordenAlfabetico == 0) {
        result.sort(function (a, b) {
          if (a.inicial < b.inicial) {
            return -1
          }
          if (a.inicial > b.inicial) {
            return 1
          }
          return 0
        })
      } else {
        result.sort(function (a, b) {
          if (a.inicial > b.inicial) {
            return -1
          }
          if (a.inicial < b.inicial) {
            return 1
          }
          return 0
        })
      }
      return result
    },
    itemsCurso() {
      return this.filteredPersonal.map((cursoPersonal) => ({
        cuip: cursoPersonal.Personal.CUIP,
        nombre: cursoPersonal.Personal.nombre,
        segundoNombre: cursoPersonal.Personal.segundoNombre,
        apaterno: cursoPersonal.Personal.apaterno,
        amaterno: cursoPersonal.Personal.amaterno,
        asistencia: cursoPersonal.asistencia,
        calificacion: cursoPersonal.calificacion,
        calificacionEvaluacion: cursoPersonal.calificacionEvaluacion,
        comentario: cursoPersonal.comentario,
      }))
    },
  },

  mounted() {
    const selectedCurso = this.cursosProgramados.find((curso) => curso.id === this.id)
    if (selectedCurso) {
      this.SET_SELECTED_CURSO_PROGRAMADO(selectedCurso)
    }
  },

  methods: {
    ...mapActions('cursoAsignado', ['updateCursoAsignado', 'fetchCursosAsignados']),
    ...mapMutations('dialog', ['SET_DIALOG']),
    ...mapMutations('cursoProgramado', ['SET_SELECTED_CURSO_PROGRAMADO']),

    save: async function () {
      this.loading = true

      this.personal.forEach((cursoPersonal) => {
        if (cursoPersonal.file) {
          cursoPersonal.evidencia = cursoPersonal.file.name
        }
      })
      console.log(this.personal)
      await this.updateCursoAsignado(this.personal)

      this.$router.push('/profesionalizacion/cursos_programados')
      this.loading = false
    },
    openEditModalCalificar(item) {
      const persona = this.personal.find((p) => p.Personal.CUIP === item.cuip)
      this.SET_DIALOG({
        ...this.DIALOG_TYPES.CALIFICAR_CURSO,
        props: { personal: persona },
      })
    },
    async openEditModalDelete(item) {
      const asignacion = this.personal.find((p) => p.Personal.CUIP === item.cuip)
      this.SET_DIALOG({
        ...this.DIALOG_TYPES.DESVINCULAR_CURSO,
        props: {
          asignacion: {
            idPersonal: asignacion.Personal.idPersonal,
            idAsignacionCurso: asignacion.id,
            nombre: asignacion.Personal.nombre,
            segundoNombre: asignacion.Personal.segundoNombre,
            apaterno: asignacion.Personal.apaterno,
            amaterno: asignacion.Personal.amaterno,
          },
        },
        listeners: {
          updated: async () => {
            await this.fetchCursosAsignados()
          },
        },
      })
    },
  },
}
</script>

<style scoped>
/* Estilos modernos para EvaluaCurso - Profesionalización */

/* Cards de estadísticas (Asistieron y Promedio) */
::v-deep .v-card.card {
  background: rgba(26, 46, 36, 0.6) !important;
  backdrop-filter: blur(10px);
  -webkit-backdrop-filter: blur(10px);
  border: 1px solid rgba(0, 210, 160, 0.3);
  border-radius: 16px;
  box-shadow: 0 8px 32px rgba(0, 0, 0, 0.3);
  transition: all 0.3s ease;
}

::v-deep .v-card.card:hover {
  border-color: rgba(0, 210, 160, 0.5);
  box-shadow: 0 12px 40px rgba(0, 210, 160, 0.3);
  transform: translateY(-2px);
}

::v-deep .v-card.card .text-subtitle-2,
::v-deep .v-card.card .text-subtitle-1 {
  color: #e0e0e0 !important;
}

::v-deep .v-card.card .font-weight-black {
  color: #26de81 !important;
}

/* Input de búsqueda */
::v-deep .v-text-field.v-text-field--filled {
  border-radius: 28px;
  overflow: hidden;
}

::v-deep .v-text-field .v-input__control {
  border-radius: 28px !important;
}

::v-deep .v-text-field input {
  color: #e0e0e0 !important;
}

::v-deep .v-text-field input::placeholder {
  color: rgba(224, 224, 224, 0.5) !important;
}

::v-deep .v-text-field .v-icon {
  color: #00d2a0 !important;
}

::v-deep .v-text-field.v-input--is-focused .v-icon {
  color: #26de81 !important;
}

/* Botones */
::v-deep .v-btn {
  border-radius: 12px !important;
  text-transform: none !important;
  font-weight: 600 !important;
  transition: all 0.3s cubic-bezier(0.175, 0.885, 0.32, 1.275) !important;
  position: relative;
  overflow: hidden;
}

::v-deep .v-btn::before {
  content: '';
  position: absolute;
  top: 50%;
  left: 50%;
  width: 0;
  height: 0;
  border-radius: 50%;
  background: rgba(255, 255, 255, 0.2);
  transform: translate(-50%, -50%);
  transition: width 0.6s, height 0.6s;
  pointer-events: none;
}

::v-deep .v-btn:active::before {
  width: 300px;
  height: 300px;
}

::v-deep .v-btn:hover:not(:disabled) {
  transform: translateY(-2px);
  box-shadow: 0 8px 24px rgba(0, 210, 160, 0.6) !important;
}

/* Botón Guardar evaluación */
::v-deep .v-btn.secondary {
  background: linear-gradient(135deg, #00d2a0 0%, #26de81 100%) !important;
  color: #ffffff !important;
  box-shadow: 0 4px 16px rgba(0, 210, 160, 0.4) !important;
}

::v-deep .v-btn.secondary .v-icon {
  transition: all 0.3s ease;
}

::v-deep .v-btn.secondary:hover .v-icon {
  transform: scale(1.2);
}

::v-deep .v-btn.secondary:disabled {
  background: rgba(26, 46, 36, 0.4) !important;
  color: rgba(224, 224, 224, 0.3) !important;
}

/* Texto de resultados de búsqueda */
::v-deep .text-h6 {
  color: #e0e0e0 !important;
}

::v-deep .text-h6 .font-weight-bold {
  color: #26de81 !important;
}

/* Data Table */
::v-deep .v-data-table {
  background: transparent !important;
  color: #e0e0e0 !important;
  border-radius: 12px;
}

/* Encabezados de tabla */
::v-deep .v-data-table-header {
  background: linear-gradient(135deg, rgba(0, 210, 160, 0.15) 0%, rgba(38, 222, 129, 0.15) 100%) !important;
}

::v-deep .v-data-table-header th {
  color: #26de81 !important;
  font-weight: 700 !important;
  font-size: 0.75rem !important;
  text-transform: uppercase;
  letter-spacing: 0.3px;
  border-bottom: 2px solid rgba(0, 210, 160, 0.3) !important;
  padding: 8px 4px !important;
  white-space: nowrap;
}

/* Filas de la tabla */
::v-deep .v-data-table tbody tr {
  transition: all 0.3s ease;
  border-radius: 8px;
}

::v-deep .v-data-table tbody tr:hover {
  background: rgba(0, 210, 160, 0.1) !important;
  transform: scale(1.005);
  box-shadow: 0 4px 12px rgba(0, 210, 160, 0.2);
}

::v-deep .v-data-table tbody td {
  color: #e0e0e0 !important;
  border-bottom: 1px solid rgba(0, 210, 160, 0.1) !important;
  padding: 8px 4px !important;
  font-size: 0.8rem;
  white-space: nowrap;
}

::v-deep .v-data-table tbody td:nth-child(9) {
  white-space: normal !important;
  max-width: 200px;
  word-break: break-word;
}

/* Iconos de asistencia */
::v-deep .v-icon.success--text {
  color: #26de81 !important;
}

::v-deep .v-icon.error--text {
  color: #ff6b6b !important;
}

/* Botones de acción en la tabla */
::v-deep .v-data-table .v-btn[icon] {
  background: rgba(26, 46, 36, 0.8) !important;
  border: 1px solid rgba(0, 210, 160, 0.3);
}

::v-deep .v-data-table .v-btn[icon]:hover:not(:disabled) {
  background: rgba(26, 46, 36, 0.95) !important;
  border-color: #00d2a0;
  transform: translateY(-2px);
  box-shadow: 0 8px 24px rgba(0, 210, 160, 0.6) !important;
}

::v-deep .v-data-table .v-btn[icon] .v-icon {
  color: #00d2a0 !important;
  transition: all 0.3s ease;
}

::v-deep .v-data-table .v-btn[icon]:hover .v-icon {
  transform: scale(1.2);
}

/* Loading state */
::v-deep .v-data-table__progress {
  background: rgba(0, 210, 160, 0.1) !important;
}

::v-deep .v-data-table__progress .v-progress-linear__determinate {
  background: linear-gradient(135deg, #00d2a0 0%, #26de81 100%) !important;
}

/* Empty state */
::v-deep .v-data-table__empty-wrapper {
  color: rgba(224, 224, 224, 0.6) !important;
}

/* Data footer */
::v-deep .v-data-footer {
  background: rgba(18, 18, 18, 0.5) !important;
  border-top: 1px solid rgba(0, 210, 160, 0.2) !important;
  color: #e0e0e0 !important;
}

::v-deep .v-data-footer__select .v-select {
  color: #e0e0e0 !important;
}

::v-deep .v-data-footer__pagination {
  color: #e0e0e0 !important;
}

/* Scrollbar */
::-webkit-scrollbar {
  width: 8px;
  height: 8px;
}

::-webkit-scrollbar-track {
  background: rgba(10, 10, 10, 0.5);
  border-radius: 4px;
}

::-webkit-scrollbar-thumb {
  background: rgba(0, 210, 160, 0.4);
  border-radius: 4px;
  transition: background 0.3s;
}

::-webkit-scrollbar-thumb:hover {
  background: rgba(0, 210, 160, 0.6);
}
</style>
